import React, { useEffect, useRef } from 'react';
import styles from 'src/pages/Design/pages/StayAfloatAnimation/StayAfloatAnimation.module.scss';

import { gsap } from 'gsap';

const StayAfloatAnimation: React.FC = () => {
  const boxRef = useRef<HTMLDivElement>(null);

  const el = useRef<HTMLDivElement>(null);
  const q = gsap.utils.selector(el);
  const timeline = useRef<gsap.core.Timeline | null>(null);

  useEffect(() => {
    // NOTE: for some reason when you do '+=360', the 360 rotation isn't exactly 360 everytime. It is around 360 like 355, 367, etc.???
    gsap.to(boxRef.current, { rotation: `360_ccw`, duration: 2 });

    timeline.current = gsap
      .timeline({ defaults: { ease: 'power1.out' } })
      .to(q(styles.text), { y: '0%', duration: 1 });
  }, []);

  return (
    <main className={styles.container}>
      <section className={styles.landing}>
        <nav>
          <h1 id={styles.logo}>Afloat</h1>
          <ul className={styles.navLinks}>
            <li>Home</li>
            <li>About</li>
            <li>Contact</li>
          </ul>
        </nav>
        <h2 className={styles.bigText}> Stay Afloat </h2>
        <div className={styles.intro}>
          <div className={styles.introText} ref={el}>
            <h1 className={styles.hide}>
              <span className={styles.text}>Creating Innovation</span>
            </h1>
            <h1 className={styles.hide}>
              <span className={styles.text}>For Everyday</span>
            </h1>
            <h1 className={styles.hide}>
              <span className={styles.text}>People</span>
            </h1>
          </div>
        </div>
        <div className={styles.slider}></div>
      </section>
    </main>
  );
};

export default StayAfloatAnimation;
